import PDFReader from "./components/PDFReader";

export default PDFReader;



// WEBPACK FOOTER //
// ./src/lib/index.js